import { render, staticRenderFns } from "./WorkShiftInformation.vue?vue&type=template&id=dbf611c2"
import script from "./WorkShiftInformation.vue?vue&type=script&lang=js"
export * from "./WorkShiftInformation.vue?vue&type=script&lang=js"
import style0 from "../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./WorkShiftInformation.vue?vue&type=style&index=1&id=dbf611c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports